/**
 * Mobility MVP: Pelvic Tilt Uploading State
 * Loading screen while video is being processed
 * Follows FIGMA #MVP-Loading-Screen pattern
 */

import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export function PelvicTiltUploading() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-[420px] w-full">
        <CardContent className="pt-6 pb-6">
          <div className="flex flex-col items-center text-center space-y-4">
            {/* Progress dots */}
            <div className="flex space-x-2">
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
            </div>

            <p className="text-base text-muted-foreground">
              Analyzing your pelvic control...
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
